import { LayoutServiceData, SitecoreContextValue } from '@sitecore-jss/sitecore-jss-nextjs';
import React, { ReactNode, useMemo } from 'react';
import { useContext } from 'react';

// An alternate Sitecore context because the built-in is not updating properly during page navigation
const SitecoreContext = React.createContext<SitecoreContextValue>({
  pageEditing: false,
} as SitecoreContextValue);

type Result = {
  sitecoreContext: SitecoreContextValue;
};
export const useSitecoreContext = (): Result => {
  const context = useContext(SitecoreContext);
  return { sitecoreContext: context };
};

export const SitecoreContextProvider: React.FC<{
  layoutData?: LayoutServiceData;
  children: ReactNode;
}> = ({ layoutData, children }) => {
  const sitecoreContextValue: SitecoreContextValue = useMemo(
    () =>
      layoutData
        ? {
            route: layoutData.sitecore.route ?? undefined,
            itemId: layoutData.sitecore.route?.itemId ?? undefined,
            ...layoutData.sitecore.context,
          }
        : ({ pageEditing: false } as SitecoreContextValue),
    [layoutData]
  );
  return (
    <SitecoreContext.Provider value={sitecoreContextValue}>{children}</SitecoreContext.Provider>
  );
};
